import { useCallback, useSyncExternalStore } from 'react';
import { PCR_ERROR_KEY } from '../store/createDocumentStore';
import { useDocumentStore } from './useDocumentStore';

// The PCR and c-PCR of the document with their options. They come from the document's digital version, not from
// the document data, so the selectors cannot use useProperty / useDataSource.
export default function usePcrSelection() {
  const store = useDocumentStore();

  const selection = useSyncExternalStore(store.addDataChangedListener, store.getPcrSelection);
  const pcrOptions = useSyncExternalStore(store.addDataChangedListener, store.getPcrOptions);
  const getCpcrOptions = useCallback(() => store.getCpcrOptions(selection.pcrId), [store, selection.pcrId]);
  const cpcrOptions = useSyncExternalStore(store.addDataChangedListener, getCpcrOptions);
  const getProductCategoryId = useCallback(
    () => store.tryGetValue<string | null>(['productCategoryId']) ?? null,
    [store]
  );
  const productCategoryId = useSyncExternalStore(store.addDataChangedListener, getProductCategoryId);
  const getPcrError = useCallback(() => store.getErrorMessage([PCR_ERROR_KEY]), [store]);
  const pcrErrorMessage = useSyncExternalStore(store.addDataChangedListener, getPcrError);

  return {
    selection,
    pcrOptions,
    cpcrOptions,
    productCategoryId,
    pcrErrorMessage,
    isDisabled: store.getIsPcrDisabled(),
  };
}
